import { RootState } from 'src/redux/createRootReducer'

export const selectCreditCardsActiveCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.creditCardsActiveCanIssueVirtualCardsCount

export const selectCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount

export const selectCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsActiveDirectEnabledCanIssueVirtualCardsCount

export const selectCreditCardsActiveSourceCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.creditCardsActiveSourceCanIssueVirtualCardsCount

export const selectCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount

export const selectCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount

export const selectCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCount

export const selectVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .virtualCardsActiveSourceUserOrViewerOrDelegateUserMeCount

export const selectVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.virtualCardsCardholderOrViewerMeActiveAndInactiveCount

export const selectBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .billPayCardsActiveSourceUserOrViewerOrDelegateUserMeCount

export const selectBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.billPayCardsCardholderOrViewerMeActiveAndInactiveCount

export const selectBillPayCardsPendingRequestsCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.billPayCardsPendingRequestsCount

export const selectCreditCardsCanIssueVirtualCardsCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsCanIssueVirtualCardsCount

export const selectCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.creditCardsSourceBudgetsEnabledCanIssueBudgetsCount

export const selectCreditCardsSourceBudgetsEnabledCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsSourceBudgetsEnabledCount

export const selectCreditCardsUserOrViewerMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsUserOrViewerMeCount

export const selectVirtualCardsPendingRequestCardholderMeCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.virtualCardsPendingRequestCardholderMeCount

export const selectCreditCardsPendingSourceUserMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsPendingSourceUserMeCount

export const selectVirtualCardsRecipientMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.virtualCardsRecipientMeCount

export const selectGuestVirtualCardsRecipientMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.guestVirtualCardsRecipientMeCount

export const selectVirtualCardsInactiveRecipientMeIssuedCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.virtualCardsInactiveRecipientMeIssuedCount

export const selectVirtualCardsActiveOrPendingRecipientMeCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics.virtualCardsActiveOrPendingRecipientMeCount

export const selectVirtualCardsCardholderPendingRequestOrApproverRuleApprovalCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .virtualCardsCardholderPendingRequestOrApproverRuleApprovalCount

export const selectVirtualCardsActiveRecipientMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.virtualCardsActiveRecipientMeCount

export const selectCreditCardsActiveDelegateCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsActiveDelegateCount

export const selectCreditCardsActiveSourceCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsActiveSourceCount

export const selectCreditCardsTimedOutSourceCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsTimedOutSourceCount

export const selectCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatisticsFromState =
  (state: RootState): number =>
    state.data.statistics
      .creditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCount

export const selectCreditCardsDelegateCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsDelegateCount

export const selectCreditCardsDelegateOwnerMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsDelegateOwnerMeCount

export const selectCreditCardsDelegateUserMeCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsDelegateUserMeCount

export const selectCreditCardsSourceCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsSourceCount

export const selectCreditCardsSourceUserOrViewerCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsSourceUserOrViewerCount

export const selectCreditCardsCountStatisticsFromState = (
  state: RootState,
): number => state.data.statistics.creditCardsCount
